/**
 * Skolverkets skolenhetsregister ger kommunkod men aldrig län. Länet härleds
 * ur kommunkodens två första siffror. Stavning och slug-form är hämtade ur
 * `education_units` som den ser ut idag — ändra inget här utan att också
 * migrera befintliga rader, filtren på /skolor matchar på exakt sträng.
 */
export const COUNTIES: Record<string, { name: string; slug: string }> = {
  "01": { name: "Stockholms län", slug: "stockholms-lan" },
  "03": { name: "Uppsala län", slug: "uppsala-lan" },
  "04": { name: "Södermanlands län", slug: "sodermanlands-lan" },
  "05": { name: "Östergötlands län", slug: "ostergotlands-lan" },
  "06": { name: "Jönköpings län", slug: "jonkopings-lan" },
  "07": { name: "Kronobergs län", slug: "kronobergs-lan" },
  "08": { name: "Kalmar län", slug: "kalmar-lan" },
  "09": { name: "Gotlands län", slug: "gotlands-lan" },
  "10": { name: "Blekinge län", slug: "blekinge-lan" },
  "12": { name: "Skåne län", slug: "skane-lan" },
  "13": { name: "Hallands län", slug: "hallands-lan" },
  "14": { name: "Västra Götalands län", slug: "vastra-gotalands-lan" },
  "17": { name: "Värmlands län", slug: "varmlands-lan" },
  "18": { name: "Örebro län", slug: "orebro-lan" },
  "19": { name: "Västmanlands län", slug: "vastmanlands-lan" },
  "20": { name: "Dalarnas län", slug: "dalarnas-lan" },
  "21": { name: "Gävleborgs län", slug: "gavleborgs-lan" },
  "22": { name: "Västernorrlands län", slug: "vasternorrlands-lan" },
  "23": { name: "Jämtlands län", slug: "jamtlands-lan" },
  "24": { name: "Västerbottens län", slug: "vasterbottens-lan" },
  "25": { name: "Norrbottens län", slug: "norrbottens-lan" },
};

export function countyFromKommunkod(kommunkod: string | null | undefined) {
  if (!kommunkod) return null;
  const code = String(kommunkod).padStart(4, "0").slice(0, 2);
  const hit = COUNTIES[code];
  if (!hit) return null;
  return { code, name: hit.name, slug: hit.slug };
}

/** Samma slug-form som redan ligger i databasen och i sitemapen. */
export function slugify(value: string): string {
  return value
    .toLowerCase()
    .replace(/[åä]/g, "a")
    .replace(/ö/g, "o")
    .replace(/é/g, "e")
    .replace(/ü/g, "u")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/**
 * Slug sätts BARA på nya rader. Befintliga slugs är frysta — de ligger i
 * sitemapen, i inlänkar och i sparade favoriter.
 */
export function buildSlug(name: string, ort: string | null | undefined, code: string): string {
  const parts = [slugify(name || "skola"), ort ? slugify(ort) : "", code].filter(Boolean);
  return parts.join("-");
}
